<template lang="pug">
  .ot-section
    .header
      .step-badge
        span.step-number {{ step }}
      .title {{ title }}
      div.ml-auto
        b-icon(
          :icon="isOpen ? 'chevron-up' : 'chevron-down'"
          v-b-toggle="`collapse-${section}-section`"
          font-scale="1.5"
          @click="openAndClose"
        )
    .content
      slot
</template>

<script>
export default {
  name: 'OTSection',
  props: ['step', 'title', 'open', 'section', 'openSection'],
  created() {
    if (this.open === true) {
      this.isOpen = this.open
    }
  },
  data() {
    return {
      isOpen: true,
    }
  },
  methods: {
    openAndClose() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.ot-section {
  margin: 12px 0;
  background: #ffffff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;

    .step-badge {
      background-color: #FECE2F;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      min-width: 40px;
      margin-right: 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      .step-number {
        color: #23201C;
        font-family: 'Noto Sans', sans-serif;
        font-weight: 700;
        font-size: 15px;
      }
    }

    .title {
      color: #23201C;
      font-family: 'Noto Sans', sans-serif;
      font-weight: 700;
      font-size: 20px;
    }

    .ml-auto {
      color: #525252;
    }
  }

  .content {
    padding: 0;
    @include media-breakpoint-down(sm) {
      padding: 0;
    }
  }
}
</style>
